import React, {useEffect} from "react";
import { Switch, Route, BrowserRouter} from "react-router-dom";
import Welcome from "../Pages/Welcome";
import Test from "../Pages/Test";
import Finish from "../Pages/Finish";
import Questionnaire from "../Pages/Questionnaire";
import ScreeningID from "../Pages/ScreeningID";
import Staff from "../Pages/Staff";
import { PATH_NAMES } from '../Utilities/Constants'
import Language from "../Pages/Language";

export default function Router() {
    useEffect(() => {
        document.body.className = 'class-name';
    }, []);
    
    return(
    <BrowserRouter>
        <Switch>
            <Route exact path={PATH_NAMES.ID} component={ScreeningID} />            
            <Route exact path={PATH_NAMES.LANGUAGE} component={Language} />
            <Route exact path={PATH_NAMES.STAFF} component={Staff} />
            <Route path={PATH_NAMES.WELCOME} component={Welcome} />
            <Route path={PATH_NAMES.QUESTIONNAIRE} component={Questionnaire}  />
            <Route path={PATH_NAMES.TEST}  component={Test} />
            <Route exact path={PATH_NAMES.FINISH} component={Finish} />
        </Switch>  
    </BrowserRouter>
    )
    
}
